import script from "./ContentsBlockDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentsBlockDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./ContentsBlockDisplay.vue?vue&type=style&index=0&id=abea8742&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abea8742"]])

export default __exports__